import React from 'react'
import styled, { withTheme } from 'styled-components'

import { Error } from './Icons'

export const TAGS_TYPES = {
  FIRST_TIME_SENDER: 'FIRST_TIME_SENDER',
  BANNER_ADDED: 'BANNER_ADDED',
  VIP_IMPERSONATION: 'VIP_IMPERSONATION',
  VIP_IMPERSONATION_WITH_BORDER: 'VIP_IMPERSONATION_WITH_BORDER',
  LOW_RISK_GREEN: 'LOW_RISK_GREEN',
  LOW_RISK_YELLOW: 'LOW_RISK_YELLOW',
  LOW_RISK_RED: 'LOW_RISK_RED',
  VIP: 'VIP',
  NEW: 'NEW',
}

const TAG_PADDING = '2px 6px 1px 6px'

const StyledTag = styled.div`
  display: inline-flex;
  border-radius: 4px;
  font-weight: ${({ theme }) => theme.typography.weight.semibold};
  padding: 2px 8px;
  line-height: 13px;
`

const getTagConfig = (type, theme) => {
  const configs = {
    [TAGS_TYPES.FIRST_TIME_SENDER]: {
      text: 'First Time Sender',
      style: {
        backgroundColor: theme.ds_gray_2,
        color: theme.white,
        textTransform: 'uppercase',
        fontSize: '10px',
      },
    },
    [TAGS_TYPES.BANNER_ADDED]: {
      text: 'Banner Added',
      leftIcon: (
        <Error
          width="12px"
          height="12px"
          fill={theme.ds_gray_2}
          style={{ margin: '0 7px 0 1px' }}
        />
      ),
      style: {
        backgroundColor: '#F3F3F3',
        color: theme.ds_gray_2,
        textTransform: 'uppercase',
        fontSize: '10px',
      },
    },
    [TAGS_TYPES.VIP_IMPERSONATION]: {
      text: 'VIP Impersonation',
      style: {
        backgroundColor: 'rgba(228, 66, 88, 0.10)',
        color: theme.negativeColor,
        fontSize: '12px',
        padding: TAG_PADDING,
      },
    },
    [TAGS_TYPES.VIP_IMPERSONATION_WITH_BORDER]: {
      text: 'VIP Impersonation',
      style: {
        backgroundColor: 'rgba(228, 66, 88, 0.10)',
        color: theme.negativeColor,
        fontSize: '12px',
        border: '1px solid rgba(228, 66, 88, 0.50)',
        height: '18px',
        padding: TAG_PADDING,
        boxSizing: 'border-box',
        alignItems: 'center',
      },
    },
    [TAGS_TYPES.LOW_RISK_GREEN]: {
      text: 'Low Risk',
      style: {
        backgroundColor: 'rgba(0, 200, 117, 0.10)',
        color: theme.positiveColor,
        fontSize: '10px',
        textTransform: 'uppercase',
      },
    },
    [TAGS_TYPES.LOW_RISK_YELLOW]: {
      text: 'Low Risk',
      style: {
        backgroundColor: 'rgba(255, 168, 0, 0.20)',
        color: theme.warningColor,
        fontSize: '10px',
        textTransform: 'uppercase',
      },
    },
    [TAGS_TYPES.LOW_RISK_RED]: {
      text: 'Low Risk',
      style: {
        backgroundColor: 'rgba(228, 66, 88, 0.10)',
        color: theme.negativeColor,
        fontSize: '10px',
        textTransform: 'uppercase',
      },
    },
    [TAGS_TYPES.VIP]: {
      text: 'VIP',
      style: {
        color: theme.primary,
        textTransform: 'uppercase',
        border: `1px solid ${theme.primary}`,
        backgroundColor: theme.ds_gray_8,
        padding: TAG_PADDING,
        fontSize: '12px',
        lineHeight: '12px',
      },
    },
    [TAGS_TYPES.NEW]: {
      text: 'New',
      style: {
        backgroundColor: theme.chart_yellow,
        color: '#003580',
        textTransform: 'uppercase',
        fontSize: '12px',
      },
    },
  }
  return configs[type]
}

const Tag = ({ id, className, type, text, theme }) => {
  const tagConfig = getTagConfig(type, theme)

  return (
    <StyledTag id={id} className={className} style={tagConfig.style}>
      {tagConfig.leftIcon}
      <span className="text">{text || tagConfig.text}</span>
    </StyledTag>
  )
}

export default withTheme(Tag)
